import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ActionButton from '../../components/ActionButton/ActionButton';
import DialogComponent from '../../components/DialogComponent/DialogComponent';
import ReactSelectMaterial from '../../components/ReactSelectMaterial/ReactSelectMaterial';
import API from '../../constants/api';
import {
    apiCatchBlockFunction,
    isArrayValidAndNotEmpty,
} from '../../constants/CommonUtil';
import { getStringFromObject } from '../../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { checkIfPrivilegeExistsForUser } from '../../constants/privilegeChecker';
import { closeCardDeviceSelect, saveCardDevice } from '../../redux/modules/cardDevice/cardDevice-actions';
import { errorMessage } from '../../redux/modules/message/message-actions';
import ValidateUserDialog from '../ValidateUserDialog/ValidateUserDialog';

class CardDeviceSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ip: {},
            port: {},
            editable: false,
            showValidateUserDialog: false,
        };
    }

    componentDidMount() {
        this.setStoredData();
    }

    setStoredData = () => {
        const { cardDevice } = this.props;
        if (isObjectValidAndNotEmpty(cardDevice.data)) {
            this.setState({
                ip: cardDevice.data.ip,
                port: cardDevice.data.port,
            }, this.checkUserHasPrivilegesToEdit);
        } else {
            this.setState({ editable: true });
        }
    };

    handleClose = () => {
        this.props.dispatch(closeCardDeviceSelect());
    };

    checkUserHasPrivilegesToEdit = () => {
        const { appConfiguration } = this.props;
        const cardPaymentIntegration = getStringFromObject('cardPaymentIntegration', appConfiguration) || {};
        const { editCardDevicePrivilege } = cardPaymentIntegration;
        if (
            isArrayValidAndNotEmpty(editCardDevicePrivilege) &&
            checkIfPrivilegeExistsForUser(editCardDevicePrivilege)
        ) {
            this.setState({ editable: true });
        }
    };

    handleSave = () => {
        const {
            ip,
            port,
        } = this.state;
        const { dispatch } = this.props;

        if (!isObjectValidAndNotEmpty(ip)) {
            dispatch(errorMessage('Must select an IP'));
            return;
        }
        if (!isObjectValidAndNotEmpty(port)) {
            dispatch(errorMessage('Must select a Port'));
            return;
        }
        dispatch(saveCardDevice({ ip, port }));
        this.handleClose();
    };

    validateUserFunction = async (loginCredentials) => {
        const {
            appConfiguration,
            dispatch,
        } = this.props;
        const cardPaymentIntegration = getStringFromObject('cardPaymentIntegration', appConfiguration) || {};
        const { editCardDevicePrivilege } = cardPaymentIntegration;
        try {
            const response = await axios.post(API.LOGIN.VALIDATE_USER_AND_GET_PRIVILEGES, loginCredentials);
            const privilegesOfUser = response.data;

            if (isArrayValidAndNotEmpty(privilegesOfUser)) {
                for (let i = 0; i < editCardDevicePrivilege.length; i += 1) {
                    const aPrivilege = editCardDevicePrivilege[i];
                    if (!privilegesOfUser.includes(aPrivilege)) {
                        dispatch(errorMessage('User does not have sufficient privilege to perform this operation'));
                        return;
                    }
                }
                this.toggleValidateUser();
                this.setState({ editable: true });
            } else {
                dispatch(errorMessage('Username or password does not match'));
            }
        } catch (e) {
            apiCatchBlockFunction(e, dispatch);
        }
    };

    makeFieldsEditableForPrivilegedUser = () => {
        const {
            dispatch,
            appConfiguration,
        } = this.props;
        const cardPaymentIntegration = getStringFromObject('cardPaymentIntegration', appConfiguration) || {};
        const { editCardDevicePrivilege } = cardPaymentIntegration;
        if (isArrayValidAndNotEmpty(editCardDevicePrivilege)) {
            this.toggleValidateUser();
        } else {
            dispatch(errorMessage('Privilege to change card device is not configured'));
        }
    };

    toggleValidateUser = () => {
        this.setState(prevState => ({
            showValidateUserDialog: !prevState.showValidateUserDialog,
        }));
    };

    handleIpSelect = (value) => {
        this.setState({
            ip: value,
        });
    }

    handlePortSelect = (value) => {
        this.setState({
            port: value,
        });
    }

    render() {
        const {
            cardDevice,
            appConfiguration,
        } = this.props;
        const {
            ip,
            port,
            editable,
            showValidateUserDialog,
        } = this.state;

        const registrationCardPaymentIntegration = getStringFromObject('registration_card_payment_integration', appConfiguration) || {};
        const { allowedIps, allowedPorts } = registrationCardPaymentIntegration;
        const dialogOpen = getStringFromObject('openSelect', cardDevice);
        return (
            <DialogComponent
                header="Select Card Device"
                open={dialogOpen}
                handleClose={this.handleClose}
                dialogActions={(
                    <ActionButton onClick={this.handleSave} className="ml-1" testId="Save">
                        Save
                    </ActionButton>
                )}
            >
                <Grid container spacing={8}>
                    {
                        !editable && (
                            <Grid item container justify="flex-end">
                                <Grid item>
                                    <ActionButton
                                        onClick={this.makeFieldsEditableForPrivilegedUser}
                                    >
                                        Edit
                                    </ActionButton>
                                </Grid>
                            </Grid>
                        )
                    }
                    <Grid item sm={6}>
                        <ReactSelectMaterial
                            options={allowedIps || []}
                            onChange={this.handleIpSelect}
                            dataSourceConfig={{
                                text: 'value',
                                value: 'key',
                            }}
                            label="IP"
                            value={ip}
                            testId="ip"
                            isDisabled={!editable}
                        />
                    </Grid>
                    <Grid item sm={6}>
                        <ReactSelectMaterial
                            options={allowedPorts || []}
                            onChange={this.handlePortSelect}
                            dataSourceConfig={{
                                text: 'value',
                                value: 'key',
                            }}
                            label="Port"
                            value={port}
                            testId="port"
                            isDisabled={!editable}
                        />
                    </Grid>
                    {
                        showValidateUserDialog && (
                            <ValidateUserDialog
                                dispatch={this.props.dispatch}
                                dialogTitle="Enter Supervisor's Username And Password"
                                onClose={this.toggleValidateUser}
                                validateFunction={this.validateUserFunction}
                            />
                        )
                    }
                </Grid>
            </DialogComponent>
        );
    }
}

CardDeviceSelect.propTypes = {
    appConfiguration: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    cardDevice: PropTypes.object,
};

CardDeviceSelect.defaultProps = {
    cardDevice: null,
};

const mapStateToProps = state => ({
    appConfiguration: getStringFromObject('appConfiguration', state),
    cardDevice: state.cardDevice,
});

export default connect(mapStateToProps)(CardDeviceSelect);
